<ng-container *ngIf="!indicators.loading">
  <gh-titled-sub-nav-options [options]="systemOptions" [label]="'system'"></gh-titled-sub-nav-options>
  <div class="borderline"></div>
  <gh-titled-sub-nav-options [options]="usersOptions" [label]="'users'"></gh-titled-sub-nav-options>
  <div class="borderline"></div>
  <gh-titled-sub-nav-options [options]="integrationsOptions" [label]="'integrations'"></gh-titled-sub-nav-options>
  <div class="borderline"></div>
  <gh-titled-sub-nav-options [options]="accountOptions" [label]="'account'"></gh-titled-sub-nav-options>
</ng-container>
